module.exports = __webpack_public_path__ + "img/illu-tree.3935b8f4.svg";